(ns practitest.frontend.reports.views
  (:require
   [practitest.frontend.pt-ts-bridge :as pt-ts :refer [GenericSearchableTree]]
   ["react-select" :default Select]
   [clojure.string :as string]
   [clojure.string :as str]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.components2.spinners :as spinners]
   [practitest.frontend.common.mixpanel :as mixpanel]
   [practitest.frontend.common-old-fe.color-pickers :as color-pickers]
   [practitest.frontend.common.format-utils :as format-utils]
   [practitest.frontend.common-old-fe.i18n :as i18n]
   [practitest.frontend.common-old-fe.logging :as log]
   [practitest.frontend.common-old-fe.modal :as m1]
   [practitest.frontend.common.permissions :as permissions]
   [practitest.frontend.reports.dnd-selector :as rdndsel]
   [practitest.frontend.reports.utils :as ru]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.subs :as subs]
   [practitest.frontend.routing.router :as router]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent :refer [with-let]]))

(defn humanize-timestamp [raw-timestamp]
  (if raw-timestamp
    (.calendar (js/moment (* raw-timestamp 1000)))
    (i18n/t :pending)))

(defn time-distance-from-now [raw-timestamp]
  (if raw-timestamp
    (.fromNow (js/moment (* raw-timestamp 1000)))
    (i18n/t :pending)))

(def download-icons
  {:excel "fa-file-excel-o"
   :html  "fa-file-code-o"
   :pdf   "fa-file-pdf-o"})

(defn dec->hex [dec]
  (-> dec str (js/parseInt 10) (.toString 16) string/upper-case))

(defn hex->dec [hex]
  (-> hex (js/parseInt 16)))

(defn combined-progress [{:keys [progress download-progress]}]
  (when progress
    (+ (* 0.8 (or progress 0))
       (* 0.2 (or download-progress 0)))))

(defn report-instance-download-btn [kind instance]
  ;; :files of the instance is a map of `kind` to {:label ... :url ...} datastructure
  ;; the URL is either the download URL, :prepare keyword, or :pending keyword
  ;; we want to do following:
  ;;
  ;; if the :url is :prepare, we want to start preparing the download
  ;; if the :url is :pending, we want to disable the button
  ;; if the :url is a string, it means that the report download is ready
  (let [{:keys [url]} (get-in instance [:files kind])
        progress      (combined-progress instance)]
    (cond
      (#{:prepare :pending} url)
      (if (nil? progress)
        [:span {:title (i18n/t :preparing_download)}
         [spinners/mux-spinner {:size :text}]]
        [:span
         {:title (let [current-user @(re-frame/subscribe [:reports/current-user])
                       runner       (or (:creating-by instance) (:created-by instance))
                       running-by   (when
                                      (and runner
                                           (not= (:id current-user)
                                                 (:id runner)))
                                      (str "\n" (i18n/t :running_by) " " (:name runner)))]
                   (if (= 1 progress)
                     (str (i18n/t :preparing_the_download) running-by)
                     (str (i18n/t :preparing_the_data) running-by)))}
         (str (.toFixed (* 100 progress)) "% ")
         [spinners/mux-spinner {:size :text}]])

      (= :disabled url)
      [:a.disabled
       {:href     "#"
        :on-click (fn [e]
                    (.preventDefault e))}
       [:i.fa.fa-fw.text-muted {:class (get download-icons kind)}]]

      (string? url)
      [:a
       {:href @(re-frame/subscribe [:reports/download-url (:rd instance) url])}
       [:i.fa.fa-fw
        {:class (get download-icons kind)
         :title (str "Download " (name kind) " file")}]]
      :else
      nil)))

(defn report-type-icon [rd]
  (case (:type rd)
    "tabular"              [:i.fa.fa-table.fa-fw {:title (i18n/t :tabular)}]
    "tabular-aggregated"   [:i.fa.fa-table.fa-fw {:title (i18n/t :tabular_aggregated)}]
    "tabular-with-steps"   [:i.fa.fa-table.fa-fw {:title (i18n/t :tabular_with_steps)}]
    "detailed"             [:i.fa.fa-list.fa-fw {:title (i18n/t :detailed)}]
    "detailed-with-attachments" [:i.fa.fa-list.fa-fw {:title (i18n/t :detailed_with_attachments)}]
    "tabular-traceability" [:i.fa.fa-list.fa-fw {:title (i18n/t :tabular_traceability)}]
    [:i.fa.fa-table.fa-fw {:title (i18n/t :tabular)}]))

(defn icon [class]
  [:i {:class class}])

(defn errors-ui []
  (let [error @(re-frame/subscribe [:reports/error])]
    (when error
      [:div.flash.alert.alert-danger.report-alert
       {:role  "alert"
        :style {:padding-bottom "6px"
                :text-align     "left"}}
       [:button.btn.btn-secondary.close.report-close-modal
        {:type     "button"
         :on-click #(re-frame/dispatch [:reports/error-msg-clean])}
        [:span {:aria-hidden "true"} [icon "fa fa-close"]]]
       [:div
        (into [:ul]
              (for [err (:errors error)]
                [:li.text-danger err]))]])))

(defn report-action-icon [{:keys [title on-click icon-class disabled?]}]
  [:a
   {:href     "#"
    :class    (when disabled? "disabled")
    :title    title
    :on-click (when-not disabled?
                        (fn [e]
                            (.preventDefault e)
                            (re-frame/dispatch [:reports/error-msg-clean])
                            (re-frame/dispatch on-click)))}
   [icon icon-class]])

(defn report-instance-row-ui [expanded instance]
  (let [reports-admin? (permissions/has-permission? "reports_admin")]
  [:tr
   {:class (when
             (or (:child? instance)
                 (contains? @expanded (:rd-id instance)))
             "info")}
   [:td.va-middle [:span.flex-row.pull-right (:entity instance) (report-type-icon (:rd instance))]]
   [:td.va-middle
    [:span.flex-row
     [:div.col-1.text-start
     {:style {:padding-left 0
              :width        "24px"}}
     (when (pos? (count (:history instance)))
       [:a
        {:href     "#"
         :on-click (fn [e]
                     (.preventDefault e)
                     (re-frame/dispatch [:reports/toggle-expand-instance (:rd-id instance)]))}
        (if (contains? @expanded (:rd-id instance))
          [:i.fa.fa-minus.fa-fw {:title (i18n/t :collapse_instances)}]
          [:i.fa.fa-plus.fa-fw {:title (i18n/t :expand_instances)}])])]
    [:div.col-8.text-start
     {:style {:padding-left 0}}
     (when (:child? instance)
       [:i.fa.fa-chevron-right.fa-fw.text-muted])
     (:name instance)
     (when (:child? instance)
       [:span.text-muted (str " (" (time-distance-from-now (:timestamp instance)) ")")])]
    [:div.col-3
     (when (:key instance)
       [:div.btn-group.pull-right
        [report-instance-download-btn :excel instance]
        (when-not (= :disabled (get-in instance [:files :html :url]))
          [report-instance-download-btn :html instance])
        (when-not (= :disabled (get-in instance [:files :pdf :url]))
          [report-instance-download-btn :pdf instance])])]]]
   [:td.text-start.va-middle
    [:p.my-8.lh-110
     {:title (:owner instance)
      :style {:overflow      "hidden"
              :text-overflow "ellipsis"
              :white-space   "nowrap"
              :width         "110px"
              :max-width     "110px"}}
     (:owner instance)]]
   [:td.text-start.va-middle
    [:p.my-8.lh-110
     {:title (get-in instance [:rd :filter-name])
      :style {:overflow      "hidden"
              :text-overflow "ellipsis"
              :white-space   "nowrap"
              :width         "100px"
              :max-width     "100px"}}
     (get-in instance [:rd :filter-name])]]
   [:td.text-end.va-middle
    [:div.col-11
     (when-not (:empty? instance)
       (humanize-timestamp (:timestamp instance)))]
    [:div.col-1
     {:style {:padding-left  0
              :padding-right 0}}
     (when (not= "manual" (get-in instance [:schedule :type]))
       [:div.schedule-status
        [:i.fa.fa-clock-o.fa-fw
         {:title "This report is scheduled"}]
        (when (:schedule_end_date (:rd instance))
          (if (:schedule_expired (:rd instance))
            [:span.schedule-text-expired
             (str (i18n/t :schedule_ended_on)
                  (format-utils/formatted-local-date (:schedule_end_date (:rd instance))))]
            [:span.schedule-text-active
             (str (i18n/t :schedule_ends_on)
                  (format-utils/formatted-local-date (:schedule_end_date (:rd instance))))]))])]]
   [:td.text-end.va-middle
    [:div.btn-group.report-actions
     (when
       (and (:child? instance)
            (> (get-in instance [:rd :last-modified])
               (get-in instance [:files :excel :ts])))
       [report-action-icon
        {:title      (str (i18n/t :rerun_modified_report)
                          " "
                          (humanize-timestamp (:timestamp instance)))
         :on-click   [:reports/recreate-report-instance (:rd instance) (:key instance)]
         :icon-class "fa fa-refresh fa-fw"}])
     (when
       (and (not (:child? instance))
            (= "manual" (get-in instance [:rd :schedule :type])))
       [report-action-icon
        {:title      (i18n/t :rerun_this_report)
         :on-click   [:reports/create-report-instance (:rd instance)]
         :icon-class "fa fa-flash fa-fw"
         :disabled? (when-not (string? (get-in instance [:files :excel :url])) true)}])
     (when (and reports-admin? (not (:child? instance)))
       [report-action-icon
        {:title      (i18n/t :clone_this_report)
         :on-click   [:reports/clone-report-definition (:rd instance)]
         :icon-class "fa fa-clone fa-fw"}])
     (when (and reports-admin? (not (:child? instance)))
       [report-action-icon
        {:title      (i18n/t :edit_this_report)
         :on-click   [:reports/edit-report-definition (:rd instance)]
         :icon-class "fa fa-pencil fa-fw"}])
     (when reports-admin?
       [report-action-icon
        {:title      (i18n/t :delete_this_report)
         :on-click   [:reports/open-confirmation-dialog
                      {:rd       (:rd instance)
                       :instance instance}]
         :icon-class "fa fa-trash-o fa-fw"}])]]]))

(defn report-instances-ui []
  (let [report-instances (re-frame/subscribe [:reports/report-instances])
        expanded         (re-frame/subscribe [:reports/expanded-instances])]
    (fn []
      [:div.row.mt-10
       {:style {:overflow-x :auto}}
       [:div.col-md-12
        {:style {:min-width 1170}}
        [:table.table.table-striped.table-bordered
         [:thead
          [:tr
           [:th.text-center
            {:style {:width "116px"}}
            (i18n/t :entity)]
           [:th.text-center (i18n/t :name)]
           [:th.text-center
            {:style {:width "130px"}}
            (i18n/t :owner)]
           [:th.text-center
            {:style {:width "120px"}}
            (i18n/t :filter)]
           [:th.text-center
            {:style {:width "260px"}}
            (i18n/t :created)]
           [:th.text-center
            {:style {:width "96px"}}
            (i18n/t :actions)]]]
         [:tbody
          (->> @report-instances
               (mapcat
                (fn [instance]
                  (if (contains? @expanded (:rd-id instance))
                    (cons instance (map #(assoc % :child? true) (:history instance)))
                    [instance])))
               (map-indexed
                (fn [i instance]
                  ^{:key i} [report-instance-row-ui expanded instance]))
               doall)]]]])))

(defn pagination-ui []
  (let [current-page (re-frame/subscribe [:reports/current-page])
        total-pages  (re-frame/subscribe [:reports/total-pages])
        pages        (re-frame/subscribe [:reports/pages])]
    (fn []
      [:nav
       {:aria-label "Page navigation"}
       (into [:ul.pagination.report-pagination]
             (concat
              [[:li
                {:class (when (= 1 @current-page) "disabled")}
                (if (= 1 @current-page)
                  [:span
                   [:span
                    {:aria-hidden             true
                     :dangerouslySetInnerHTML {:__html "&laquo;"}}]]
                  [:a
                   {:href       "#"
                    :aria-label "Previous"
                    :on-click   (fn [e]
                                  (.preventDefault e)
                                  (re-frame/dispatch [:reports/set-page (dec @current-page)]))}
                   [:span
                    {:aria-hidden             true
                     :dangerouslySetInnerHTML {:__html "&laquo;"}}]])]]
              (for [page @pages]
                [:li
                 {:class (when (= @current-page page) "active")}
                 (if (= @current-page page)
                   [:span page [:span.sr-only "(current)"]]
                   [:a
                    {:href     "#"
                     :on-click (fn [e]
                                 (.preventDefault e)
                                 (re-frame/dispatch [:reports/set-page page]))}
                    page])])
              [[:li
                {:class (when (= @total-pages @current-page) "disabled")}
                (if (= @total-pages @current-page)
                  [:span
                   [:span
                    {:aria-hidden             true
                     :dangerouslySetInnerHTML {:__html "&raquo;"}}]]
                  [:a
                   {:href       "#"
                    :aria-label "Next"
                    :on-click   (fn [e]
                                  (.preventDefault e)
                                  (re-frame/dispatch [:reports/set-page (inc @current-page)]))}
                   [:span
                    {:aria-hidden             true
                     :dangerouslySetInnerHTML {:__html "&raquo;"}}]])]]))])))

(defn migration-banner []
  (let [has-migrated? @(re-frame/subscribe [:reports/has-migrated-reports?])]
    (when has-migrated?
      [:div.alert.alert-info.text-start.my-8
       [:i.fa.fa-info-circle.fa-fw]
       (i18n/t :migrated_reports_banner)])))

(defn reports-ui []
  (let [current-view (re-frame/subscribe [:reports/view])
        reports-admin? (permissions/has-permission? "reports_admin")
        new-report-handler (fn [_]
                            (.track js/mixpanel "Create New Report")
                            (re-frame/dispatch [:reports/error-msg-clean])
                            (re-frame/dispatch [:reports/new-report-definition]))
        query-params (router/get-current-query-params)
        open-modal? (and reports-admin? (= (:open-modal query-params) "true"))]
    (when open-modal? (new-report-handler nil))
    (fn []
      [:div.col-md-12.text-center
       [errors-ui]
       [migration-banner]
       [:div.row
        [:div.col-md-2.text-start.reports-toolbar
         (when reports-admin?
           [:button.btn.btn-primary.btn-modal-color
            {:type     :button
             :on-click new-report-handler}
            [:i.fa.fa-plus.fa-fw]
            (i18n/t :new_report)])]
        [:div.col-md-8.text-center
         [pagination-ui]]
        [:div.col-md-2]]
       [report-instances-ui]])))

(defn report-definition-fields-ui [label fields edit-mode action]
  [:div.row.pt-2.mt-lg-5
   [:label.col-12.report-input-label label]
   [:div.col-12.pt-1
    [:div.border-gray.flex
     (into [:div.fields-container]
           (for [field fields]
             [:span.item field]))
     [:div.r-25.pull-right.reports-notify
      [:a
       {:href     "#"
        :on-click (fn [e]
                    (.preventDefault e)
                    (reset! edit-mode action))
        :style    {:font-weight  "bold"
                   :font-size    "1em"
                   :padding-left "6px"}}
       [:i.fa.fa-edit.fa-lg.mr-10]]]]]])

(defn report-definition-items-selector [left right save-fn cancel-fn]
  [rdndsel/selector-ui
   {:left-header  [:h5 (:header left)]
    :right-header [:h5 (:header right)]
    :left-items   (for [[id label] (:items left)]
                    [id [:div [:i.fa.fa-arrows.fa-fw] [:span {:style {:padding-left "8px"}} label]]])
    :right-items  (for [[id label] (:items right)]
                    [id [:div [:i.fa.fa-arrows.fa-fw] [:span {:style {:padding-left "8px"}} label]]])
    :save-fn      save-fn
    :cancel-fn    cancel-fn}])

(defn field-label [field]
  (if (= "object" (:type field))
    (str (:name field) " (JSON)")
    (:name field)))

(defn modal-report-definition-fields-ui [edit-mode]
  (let [all-fields      (re-frame/subscribe [:reports/current-all-fields])
        selected-fields (re-frame/subscribe [:reports/current-selected-fields])]
    (fn [edit-mode]
      (let [fields-map (->> @all-fields
                            (map
                             (fn [field]
                               [(:field field) field]))
                            (into {}))
            fields     (->> @selected-fields
                            (map #(get fields-map %))
                            (remove nil?)
                            (map field-label))]
        [report-definition-fields-ui
         (i18n/t :selected_fields)
         fields
         edit-mode
         :customize-fields]))))

(defn modal-report-definition-aggregation-ui [edit-mode entity]
  (let [fields (re-frame/subscribe [:reports/aggregation-fields @entity])
        rd     (re-frame/subscribe [:reports/current-rd])]
    (fn []
      [:<>
       [:div.row.pt-2
        [:label.col-3.report-input-label (i18n/t :x_field) [:span.text-danger "(*)"]]
        [:div.col-9.pt-1
         (let [selected (:aggregation-x-field @rd)]
           (if (:id @rd)
             [:p.form-control-static
              (->> @fields (filter #(= selected (first %))) first last)]
             (into [:div.border-gray.col-12.fields-radio-container]
                   (for [[id name] @fields]
                     [:span.tabular-fields.radio.col-12
                      [:input
                       {:name      :x-field
                        :type      :radio
                        :checked   (= selected id)
                        :disabled  (= id (:aggregation-y-field @rd))
                        :on-change #(re-frame/dispatch [:reports/update-current-rd :aggregation-x-field id])}]
                      (str " " name)]))))]
        [:div.col-9.offset-3.pt-1.my-15
         [:div.checkbox.col-12
          [:label
           [:input
            {:type      :checkbox
             :checked   (boolean (:aggregation-x-field-empty-values @rd))
             :disabled  (boolean (:id @rd))
             :on-change #(re-frame/dispatch
                          [:reports/update-current-rd
                           :aggregation-x-field-empty-values
                           (-> % .-target .-checked)])}]
           " "
           (i18n/t :dont_show_empty_columns)]]]]
       [:div.row.pt-1
        [:label.col-3.report-input-label (i18n/t :y_field)]
        [:div.col-9
         (let [selected (:aggregation-y-field @rd)]
           (if (:id @rd)
             [:p.form-control-static
              (or (->> @fields (filter #(= selected (first %))) first last) "None")]
             (into [:div.border-gray.col-12.fields-radio-container]
                   (for [[id name] (cons [nil "None"] @fields)]
                     [:span.tabular-fields.radio.col-12
                      [:input
                       {:name      :y-field
                        :type      :radio
                        :checked   (= selected id)
                        :disabled  (and (:aggregation-x-field @rd)
                                        (= id (:aggregation-x-field @rd)))
                        :on-change #(re-frame/dispatch [:reports/update-current-rd
                                                        :aggregation-y-field id
                                                        :aggregation-y-field-empty-values (some? id)])}]
                      (str " " name)]))))]
        [:div.col-9.offset-3.pt-1.my-15
         (when (:aggregation-y-field @rd)
           [:div.checkbox.col-12
            [:label
             [:input
              {:type      :checkbox
               :checked   (boolean (:aggregation-y-field-empty-values @rd))
               :disabled  (boolean (:id @rd))
               :on-change #(re-frame/dispatch
                            [:reports/update-current-rd
                             :aggregation-y-field-empty-values
                             (-> % .-target .-checked)])}]
             " "
             (i18n/t :dont_show_empty_rows)]])]
        [:div.col-12
         [:span.help-block.pt-1
          (if (= "Run" @entity)
            (i18n/t :aggregate_run_help_block)
            (i18n/t :aggregate_instance_help_block))]]]])))

(defn modal-report-definition-charts-ui [edit-mode]
  (let [all-charts      (re-frame/subscribe [:reports/current-all-charts])
        selected-charts (re-frame/subscribe [:reports/current-selected-charts])]
    (fn [edit-mode]
      (let [fields-map (->> @all-charts
                            (map
                             (fn [field]
                               [(:field field) field]))
                            (into {}))
            charts     (->> @selected-charts
                            (map #(get-in fields-map [% :name]))
                            (remove nil?))]
        (log/info :modal-report-definition-charts-ui fields-map charts)
        [report-definition-fields-ui
         (i18n/t :selected_charts)
         charts
         edit-mode
         :customize-charts]))))

(defn modal-report-definition-users-ui [edit-mode]
  (let [all-users (re-frame/subscribe [:reports/users])
        rd        (re-frame/subscribe [:reports/current-rd])]
    (fn [edit-mode]
      (let [users-map (->> @all-users
                           (map
                            (fn [user]
                              [(:id user) user]))
                           (into {}))
            users     (map #(get-in users-map [% :name]) (:notify @rd))]
        [report-definition-fields-ui
         (i18n/t :notify_by_email)
         users
         edit-mode
         :customize-notify]))))

(defn modal-report-definition-name-ui []
  (let [rd    (re-frame/subscribe [:reports/current-rd])
        state (reagent/atom nil)]
    (fn []
      [:div.row
       [:label.col-2.report-input-label
        (i18n/t :report_name)]
        [:div.col-10
         [:input.col-12.modal-background-color.report-input
          {:type          :text
           :default-value (:name @rd)
           :ref           #(reset! state %)
           :on-change     #(re-frame/dispatch [:reports/update-current-rd :name (.-value @state)])}]]])))

(defn modal-report-definition-testset-id-ui []
  (let [rd    (re-frame/subscribe [:reports/current-rd])
        state (reagent/atom nil)]
    (fn []
        (let [new? (nil? (:id @rd))]
             [:div.row.pt-2
              [:label.form-label.light-label.col-3 (i18n/t :by_testset_id)]
              (if new?
                [:div.col-9
                 [:input.col-12.modal-background-color.report-input
                  {:type          :number
                   :default-value (:testset-id @rd)
                   :min           1
                   :ref           #(reset! state %)
                   :on-change     #(re-frame/dispatch [:reports/update-current-rd :testset-id (.-value @state)])}]]
                [:div.col-9
                 [:p.form-control-static
                  (str (:testset-id @rd))]])]))))

(defn modal-inline-radio
  ([subscription name label checked-f change-f]
   (modal-inline-radio subscription name label checked-f change-f false))
  ([subscription name label checked-f change-f disabled?]
   (let [data (re-frame/subscribe subscription)]
     (fn [subscription name label checked-f change-f disabled?]
       [:label.radio-inline
        {:class (if (= label "No") "mr-10" "ml-10")}
        [:input.mr-5
         {:name      name
          :type      :radio
          :disabled  disabled?
          :checked   (boolean (checked-f @data))
          :on-change #(change-f (= "on" (-> % .-target .-value)))}]
        label]))))

(defn modal-inline-radio-btn [subscription label checked-f change-f class add-border?]
  (let [data (re-frame/subscribe subscription)]
    (fn [subscription label checked-f change-f class add-border?]
      (let [active? (boolean (checked-f @data))]
        [:button.c-btn
         {:type         :button
          :class        (str (when active? "active") (when add-border? " r-border") " " class)
          :aria-pressed active?
          :on-click     #(change-f)}
         label]))))

(defn modal-inline-radio-text [subscription name label checked-f change-f add-border?]
  (let [data (re-frame/subscribe subscription)]
    (fn [subscription name label checked-f change-f add-border?]
      (let [active? (boolean (checked-f @data))]
        [:button.c-btn
         {:type         :button
          :name         name
          :class        (str (when active? "active") (when add-border? " r-border") " col-4")
          :aria-pressed active?
          :on-click     #(change-f true)}
         label]))))

(defn modal-inline-checkbox
  ([subscription name label checked-f change-f]
   (modal-inline-checkbox subscription name label checked-f change-f false))
  ([subscription name label checked-f change-f disabled?]
   (let [data (re-frame/subscribe subscription)]
     (fn [subscription name label checked-f change-f disabled?]
       (let [checked? (boolean (checked-f @data))]
         [:label.checkbox-inline.col
          [:input
           {:name      name
            :type      :checkbox
            :disabled  disabled?
            :checked   checked?
            :on-change #(change-f (not checked?))}]
          label])))))

(defn uglify-styles []
  #js {:control (fn [base]
                  (js/Object.assign
                    (clj->js base)
                    #js {:backgroundColor "#edf1f2"
                         :width "100%"
                         :padding "0px"
                         :border "1px solid var(--pt-color-border-light)"}))
       :valueContainer (fn [base]
                         (js/Object.assign
                           (clj->js base)
                           #js {:padding "0px 8px"}))
       :input (fn [base]
                (js/Object.assign
                  (clj->js base)
                  #js {:color "black"}))
       :menu (fn [base]
               (js/Object.assign
                 (clj->js base)
                 #js {:backgroundColor "#edf1f2"
                      :border "1px solid var(--pt-color-border-light)"
                      :width "90%"}))
       :dropdownIndicator (fn [base]
                            (js/Object.assign
                              (clj->js base)
                              #js {:color "black"}))
       :placeholder (fn [base]
                      (js/Object.assign
                        (clj->js base)
                        #js {:color "black"}))})

(defn modal-report-definition-filter-ui []
  (let [rd            (re-frame/subscribe [:reports/current-rd])
        cvs           (re-frame/subscribe [:reports/current-cvs])
        fields        (re-frame/subscribe [:reports/fields])
        run-fields    @(re-frame/subscribe [:reports/run-field-filter-fields])
        current-project @(re-frame/subscribe [::subs/current-project]) 
        current-user @(re-frame/subscribe [::subs/current-user])
        user-id (str (:id current-user))
        project-id (str (:id current-project))
        entity        (re-frame/subscribe [:reports/selected-entity])
        entity-filter (if (or (= "Instance" @entity) (= "Run" @entity)) "TestSet" @entity)
        data (re-frame/subscribe [:reports/modal-data])]
    (fn []
      (with-let [init_rd  @rd]
        (let [new? (nil? (:id @rd))]
          [:div.row.pt-2
           [:label.col-12.report-input-label (i18n/t :filter_report_by)]

           [:div.col-12.pt-1
            [:div.row
             [:div.col-4.pt-0_5
              [:label.form-label.light-label
               (str "- " (i18n/t (keyword (str entity-filter "_filter"))))]]
             (if new?
               (let [fsm (ru/fields-map (get @fields (keyword (:entity @rd))))]
                 [:div.col-8
                  [:> GenericSearchableTree {:urls        {:fetchRootTreeUrl (broutes/get-url "custom_views#by_entity"
                                                                                              {:p_id project-id}
                                                                                              {:entity_name entity-filter
                                                                                               :views_count -1})
                                                           :fetchTreeNode (broutes/get-url "custom_views#fetch_filter"  {:p_id project-id}  {:entity_name entity-filter})
                                                           :search (broutes/get-url "custom_views#search"  {:p_id project-id}  {:entity_name entity-filter})}
                                             :customClassName "report-searchable-tree"
                                             :selectedValue     (let [{:keys [filter-by filter-by-af]} @rd]
                                                                  (if filter-by-af
                                                                    (str filter-by "-" filter-by-af)
                                                                    (str (or filter-by ""))))
                                             :onChange (fn [%] 
                                                         (let [js-obj (js->clj % :keywordize-keys true)
                                                               v (first (string/split (:id js-obj) #"/"))
                                                               is-clear? (= v "_DEFAULT_")
                                                               af-value    (if (contains? js-obj :auto_filter) (:auto_filter js-obj) nil)

                                                               combined-filter   (if (and v (not (str/blank? v)))

                                                                                   (if af-value
                                                                                     (let [processed-af-value (map #(if (str/blank? %) "nil" (str "\"" % "\"")) af-value)]
                                                                                       (str v "-[" (str/join ", " processed-af-value) "]"))
                                                                                     (js/parseInt v))
                                                                                   v)

                                                               fs           (if (= (:type @rd) "tabular-traceability")
                                                                              []
                                                                              (if (:def-fields? @data)
                                                                                (or (:definition js-obj)
                                                                                    (->> (last (first (if (and v (not (js/isNaN v)))
                                                                                                        (filter #(= combined-filter (second %)) @cvs)
                                                                                                        @cvs)))
                                                                                         (filter #(contains? fsm %))))
                                                                                (:fields @rd)))


                                                               charts       (if (:def-charts? @data)
                                                                              (ru/chart-fields fsm fs)
                                                                              (:charts @rd))]

                                                           (if is-clear?
                                                             (if (:def-fields? @data)
                                                               (re-frame/dispatch [:reports/update-entity (:entity @rd)])
                                                               (re-frame/dispatch [:reports/update-current-rd :filter-by nil :filter-by-af nil]))
                                                             (re-frame/dispatch
                                                              [:reports/update-current-rd
                                                               :filter-by   (when-not (string/blank? v) v)
                                                               :filter-by-af af-value
                                                               :fields      fs
                                                               :charts      charts]))))
                                             
                                             :initialSelectedItem (when init_rd
                                                                    {:id (:filter-by init_rd)
                                                                     :auto_field (when (:filter-by-af init_rd)
                                                                                   (->> (:filter-by-af init_rd)
                                                                                        (remove nil?)
                                                                                        (string/join ";")))
                                                                     :name (:filter-name init_rd)})
                                             :scope {:module entity-filter
                                                     :tab "filters"
                                                     :user-id (str (:id @(re-frame/subscribe [::subs/current-user])))
                                                     :project-id (str (:id @(re-frame/subscribe [::subs/current-project])))}}]])

               [:div.col-8.pt-0_5
                [:p.form-control-static
                 (str
                  (->> @cvs
                       (filter #(= (:filter-by @rd) (second %)))
                       ffirst)
                  (when-let [filter-by-af (:filter-by-af @rd)]
                    (str ": " (if (sequential? filter-by-af)
                                (string/join "; " (remove string/blank? filter-by-af))
                                filter-by-af))))]])]]


           (when (= "Run" @entity)
             (if new?
               (let [run-filter-by          (:run-filter-by @rd)
                     run-filter-by-criteria (:run-filter-by-criteria @rd)
                     pvs                    (ru/run-filter-by-criteria-pvs run-fields run-filter-by)]
                 (log/info pvs)
                 [:div.col-12.pt-5.pb-6
                  [:div.row
                   [:div.col-4.pt-0_5
                    [:label.form-label.light-label (str "- " (i18n/t :run_filter))]]
                   [:div.col-8
                    [:select.col-6.modal-background-color.mdb-select.md-form.report-input
                     {:value     (str run-filter-by)
                      :on-change (fn [e]
                                   (let [v (some-> e .-target .-value)]
                                     (re-frame/dispatch
                                      [:reports/update-current-rd
                                       :run-filter-by          v
                                       :run-filter-by-criteria (first (ru/run-filter-by-criteria-pvs run-fields v))])))}
                     [:option {:value [] :defaultValue "true"} "All Runs (No filter)"]
                     (doall
                      (for [[i [u-name name _pv]] (map-indexed vector run-fields)]
                        ^{:key i} [:option {:value u-name} name]))]

                    [:select.col-6.modal-background-color.mdb-select.md-form.select-disabled-bg.report-input
                     {:value     (str run-filter-by-criteria)
                      :on-change (fn [e]
                                   (let [v (some-> e .-target .-value)]
                                     (re-frame/dispatch
                                      [:reports/update-current-rd
                                       :run-filter-by-criteria
                                       v])))
                      :disabled  (string/blank? (:run-filter-by @rd))}
                     (doall
                      (for [[i pv] (map-indexed vector pvs)]
                        ^{:key i} [:option {:value pv} pv]))]]]])
               [:div.col-12
                [:p.form-control-static
                 (if (nil? (:run-filter-by-criteria @rd))
                   (str "All Runs (No Filter)")
                   (let [rfb (->> run-fields
                                  (filter #(= (:run-filter-by @rd) (first %)))
                                  first
                                  second)]
                     (str "By Run Filter: " rfb ","
                          " Criteria is: " (:run-filter-by-criteria @rd))))]]))

           (when
            (and (or (= "Instance" (:entity @rd)) (= "Run" (:entity @rd)))
                 (not= "tabular-aggregated" (:type @rd)))
             (if new?
               (let [statuses @(re-frame/subscribe [:reports/run-statuses])
                     mapped-statuses (map (fn [v] {:value v :label v}) statuses)]
                 [:div.col-12
                  [:div.row
                   [:div.col-4.pt-0_5
                    (if (= "Run" @entity)
                      [:label.form-label.light-label (i18n/t :run_run_statuses)]
                      [:label.form-label.light-label (i18n/t :instance_run_statuses)])]
                   [:> Select
                    {:className "col-8 report-select"
                     :styles (uglify-styles)
                     :closeMenuOnSelect false
                     :placeholder       (str " " (i18n/t :all_statuses))
                     :isClearable true
                     :isMulti true
                     :options mapped-statuses
                     :width             "100%"
                     :onChange (fn [v]
                                 (let [converted-vals (js->clj v :keywordize-keys true)
                                       selected-statuses (vec (map :value converted-vals))]
                                   (log/info :multiselect "on-save" selected-statuses)
                                   (re-frame/dispatch
                                    [:reports/update-current-rd
                                     :filter-by-status
                                     (if (contains? (set selected-statuses) "")
                                       nil
                                       selected-statuses)])))}]]])
               [:div.col-12
                [:p.form-control-static
                 (when-let [status (:filter-by-status @rd)]
                   (str "Status: " status))]]))])))))

(defn modal-report-definition-instance-tabular-summary-filter-ui []
      (let [rd    (re-frame/subscribe [:reports/current-rd])
            filter-mode   (reagent/atom
                            (if (= "by_testset_id" (:generate-by @rd))
                              :by_testset_id
                              :by_filter))]
           (fn []
               (let [new? (nil? (:id @rd))]
               [:div.row.pt-2
                [:label.col-3.pull-start.report-input-label.mb-15
                 (i18n/t :generate_by)]
                [:div.col-6
                 [modal-inline-radio
                  [:reports/current-rd]
                  :generate_by
                  (i18n/t :filter)
                  (fn [_]
                      (= :by_filter @filter-mode))
                  (fn [on?]
                      (when on?
                            (reset! filter-mode :by_filter)
                            (re-frame/dispatch [:reports/update-current-rd :generate-by "by_filter"])
                            (re-frame/dispatch [:reports/update-current-rd :testset-id nil])))
                  (not new?)]

                 [modal-inline-radio
                  [:reports/current-rd]
                  :generate_by
                  (i18n/t :id)
                  (fn [_]
                      (= :by_testset_id @filter-mode))
                  (fn [on?]
                      (when on?
                            (reset! filter-mode :by_testset_id)
                            (re-frame/dispatch [:reports/update-current-rd :generate-by "by_testset_id"])))
                  (not new?)]]

                [:div.pr-15.pl-15
                 (if (= :by_filter @filter-mode)
                   [modal-report-definition-filter-ui]
                   [modal-report-definition-testset-id-ui])]]))))

(defmulti report-definition-detailed-options :entity)

(defmethod report-definition-detailed-options "Issue"
  [_]
  [[:include-description (i18n/t :description)]
   [:include-fields (i18n/t :fields)]
   [:include-traceability (i18n/t :traceability)]
   [:include-history (i18n/t :history)]
   [:include-comments (i18n/t :comments)]])
(defmethod report-definition-detailed-options "Test"
  [_]
  [[:include-description (i18n/t :description)]
   [:include-fields (i18n/t :fields)]
   [:include-steps (i18n/t :steps)]
   [:include-traceability (i18n/t :traceability)]
   [:include-history (i18n/t :history)]
   [:include-comments (i18n/t :comments)]])
(defmethod report-definition-detailed-options "Requirement"
  [_]
  [[:include-description (i18n/t :description)]
   [:include-fields (i18n/t :fields)]
   [:include-traceability (i18n/t :traceability)]
   [:include-history (i18n/t :history)]
   [:include-comments (i18n/t :comments)]])
(defmethod report-definition-detailed-options :default
  [_]
  [])

(defmulti report-definition-detailed-options-ro :entity)

(defmethod report-definition-detailed-options-ro "Issue"
  [rd]
  (str "("
       (if (:include-description rd) "with" "without") " description, "
       (if (:include-fields rd) "with" "without") " fields, "
       (if (:include-traceability rd) "with" "without") " traceability, "
       (if (:include-history rd) "with" "without") " history, "
       (if (:include-comments rd) "with" "without") " comments"
       ")"))
(defmethod report-definition-detailed-options-ro "Test"
  [rd]
  (str "("
       (if (:include-description rd) "with" "without") " description, "
       (if (:include-fields rd) "with" "without") " fields, "
       (if (:include-steps rd) "with" "without") " steps, "
       (if (:include-traceability rd) "with" "without") " traceability, "
       (if (:include-history rd) "with" "without") " history, "
       (if (:include-comments rd) "with" "without") " comments"
       ")"))
(defmethod report-definition-detailed-options-ro "Requirement"
  [rd]
  (str "("
       (if (:include-description rd) "with" "without") " description, "
       (if (:include-fields rd) "with" "without") " fields, "
       (if (:include-traceability rd) "with" "without") " traceability, "
       (if (:include-history rd) "with" "without") " history, "
       (if (:include-comments rd) "with" "without") " comments"
       ")"))
(defmethod report-definition-detailed-options-ro :default
  [_]
  "")

(defn modal-report-definition-type-ui []
  (let [rd (re-frame/subscribe [:reports/current-rd])]
    (fn []
      (let [new?             (nil? (:id @rd))
            detailed-options (report-definition-detailed-options @rd)
            ;; We assume only detailed reports show this section
            detailed-instance? (= "Instance" (:entity @rd))]
        [:<>
         (when (not (empty? detailed-options))
           [:div.row.pt-2
            [:label.col-12.form-label (i18n/t :report_sections)]
            (if new?
              [:div.col-12.pt-1.pl-5
               (into [:<>]
                     (for [[name label] detailed-options]
                       [modal-inline-checkbox
                        [:reports/current-rd]
                        name
                        label
                        name
                        #(re-frame/dispatch [:reports/update-current-rd name %])]))]
              [:div.col-12
               [:p.form-control-static
                (str "Detailed " (report-definition-detailed-options-ro @rd))]])])

         ;; Special option for detailed instance reports
         (when detailed-instance?
           [:<>
            [:div.row.pt-2.include-lastrun-fields-section
             (if new?
               [:div.col-12.pt-1.pl-5
                [modal-inline-checkbox
                 [:reports/current-rd]
                 :include-lastrun-fields
                 (i18n/t :include_lastrun_fields)
                 :include-lastrun-fields
                 #(re-frame/dispatch [:reports/update-current-rd :include-lastrun-fields %])]]
               [:div.col-12
                (when (:include-lastrun-fields @rd)
                  [:p.form-control-static
                   (i18n/t :include_lastrun_fields)])])]])]))))

(defn modal-report-definition-schedule-ui []
  (let [rd          (re-frame/subscribe [:reports/current-rd])
        edit-mode   (reagent/atom
                     (if (= "manual" (get-in @rd [:schedule :type]))
                       :manual
                       :scheduled))
        enterprise? (re-frame/subscribe [:reports/enterprise?])]
    (fn []
      [:div.pt-2
       [:label.col-12.report-input-label (i18n/t :scheduled)]
       [:div.col-12.pt-1
        [modal-inline-radio
         [:reports/current-rd]
         :scheduled
         (i18n/t :no_schedule)
         (fn [_]
           (= :manual @edit-mode))
         (fn [on?]
           (when on?
             (reset! edit-mode :manual)
             (re-frame/dispatch [:reports/update-current-rd :schedule {:type "manual"}])))]
        [modal-inline-radio
         [:reports/current-rd]
         :scheduled
         (i18n/t :yes_schedule)
         (fn [_]
           (= :scheduled @edit-mode))
         (fn [on?]
           (when on?
             (.track js/mixpanel "Report Schedule On")
             (reset! edit-mode :scheduled)
             (re-frame/dispatch [:reports/update-current-rd :schedule {:type "daily"}])))
         (not @enterprise?)]
        [:div.row.pt-1
         (when (= :scheduled @edit-mode)
           [:div.row.pt-1
            [:div.col-sm-12
             [:div.col-sm-12
              [:div.border-gray.flex.text-center
               [modal-inline-radio-text
                [:reports/current-rd]
                :schedule
                (i18n/t :daily)
                #(= "daily" (get-in % [:schedule :type]))
                #(when %
                  (re-frame/dispatch
                   [:reports/update-current-rd
                    :schedule
                    {:type "daily"}]))
                true]
               [modal-inline-radio-text
                [:reports/current-rd]
                :schedule
                (i18n/t :weekly)
                #(= "weekly" (get-in % [:schedule :type]))
                #(when %
                  (re-frame/dispatch
                   [:reports/update-current-rd
                    :schedule
                    {:type "weekly" :week-day "sunday"}]))
                true]
               [modal-inline-radio-text
                [:reports/current-rd]
                :schedule
                (i18n/t :monthly)
                #(= "monthly" (get-in % [:schedule :type]))
                #(when %
                  (re-frame/dispatch
                   [:reports/update-current-rd
                    :schedule
                    {:type "monthly" :month-day "first"}]))
                false]]]]])
         [:div.col-md-12
          (let [end-date-str (or (:schedule_end_date @rd)
                                 (.format (-> (js/moment) (.add 12 "months")) "YYYY-MM-DD"))
                end-date-display (format-utils/formatted-local-date end-date-str)
                expired? (:schedule_expired @rd)
                end-date-ui [:<>
                            " "
                            (if expired?
                              [:span.schedule-text-expired
                               (str (i18n/t :schedule_ended_on) end-date-display)]
                              [:span.text-muted
                               (str (i18n/t :schedule_ends_on) end-date-display)])
                            [:button.btn.btn-xs.btn-primary.btn-modal-color.schedule-reactivate-btn
                             {:disabled (nil? (:id @rd))
                              :on-click (fn [e]
                                          (.preventDefault e)
                                          (re-frame/dispatch [:reports/reactivate-schedule @rd]))}
                             (i18n/t :reactivate)]]]
            (case (get-in @rd [:schedule :type])
              "manual"
              [:div.p-2.bg-light.border.mt-8
               [:div.schedule-details.text-center
                [:p.help-block (i18n/t :run_report_manually)]]]

              "daily"
              [:div.schedule-details
               [:div.pt-1.schedule-info
                [:span.text-muted (i18n/t :run_every_day)]
                end-date-ui]]

              "weekly"
              [:div.schedule-details
               [:div.my-8]
               [:div.border-gray.flex
                (for [[i [day label]] (map-indexed vector
                                                   [["sunday" "Su"]
                                                    ["monday" "Mo"]
                                                    ["tuesday" "Tu"]
                                                    ["wednesday" "We"]
                                                    ["thursday" "Th"]
                                                    ["Friday" "Fr"]
                                                    ["Saturday" "Sa"]])]
                  ^{:key i}
                  [modal-inline-radio-btn
                   [:reports/current-rd]
                   label
                   #(= day (get-in % [:schedule :week-day]))
                   #(re-frame/dispatch
                     [:reports/update-current-rd
                      :schedule
                      {:type "weekly" :week-day day}])
                   "col-7-12"
                   (not (= i 6))])]
               [:div.pt-1.schedule-info
                [:span.text-muted (i18n/t :run_every_week)]
                end-date-ui]]

              "monthly"
              [:div.schedule-details
               [:div.my-8]
               [:div.border-gray.flex
                (for [[i [day label class]] (map-indexed vector
                                                         [["first" (i18n/t :first_day) "col-5"]
                                                          ["15th" "15th" "col-2"]
                                                          ["last" (i18n/t :last_day) "col-5"]])]
                  ^{:key i}
                  [modal-inline-radio-btn
                   [:reports/current-rd]
                   label
                   #(= day (get-in % [:schedule :month-day]))
                   #(re-frame/dispatch
                     [:reports/update-current-rd
                      :schedule
                      {:type "monthly" :month-day day}])
                   class
                   (not (= i 2))])]
               [:div.pt-1.schedule-info
                [:span.text-muted (i18n/t :run_every_month)]
                end-date-ui]]))]]]])))

(def ^:const traceability-max-fields 10)

(defn customize-fields-ui [edit-mode]
  (let [all-fields      (re-frame/subscribe [:reports/current-all-fields])
        entity          (re-frame/subscribe [:reports/selected-entity])
        selected-fields (re-frame/subscribe [:reports/current-selected-fields])
        report-type     (re-frame/subscribe [:reports/selected-type])
        error           (reagent/atom nil)]
    (fn [edit-mode]
      [:<>
       [:div.row
        [:div.col-md-12
         [:h5
          [:div.small-gray.mb-15
           (i18n/t :field_selection_help)]]]]
       (when @error
         [:div.alert.alert-danger.mt-8 @error])
       (let [fields-map    (->> @all-fields
                                (map
                                 (fn [field]
                                   [(:field field) field]))
                                (into {}))
             displayed     (->> @selected-fields
                                (map
                                 (fn [field]
                                   (when-let [fd (get fields-map field)]
                                     [field (field-label fd)])))
                                (remove nil?))
             displayed-set (set @selected-fields)
             available     (->> @all-fields
                                (remove #(contains? displayed-set (:field %)))
                                (map
                                 (fn [field]
                                   [(:field field) (field-label field)])))]
         [report-definition-items-selector
          {:header (i18n/t :available)
           :items  available}
          {:header (i18n/t :displayed)
           :items  displayed}
          (fn [left right]
            (if (and (= @report-type "tabular-traceability")
                     (> (count right) traceability-max-fields))
              (reset! error (i18n/t :traceability_fields_limit))
              (do
                (reset! error nil)
                (re-frame/dispatch
                 [:reports/update-current-rd :fields (map first right)])
                (reset! edit-mode :create-screen))))
          (fn []
            (reset! error nil)
            (reset! edit-mode :create-screen))])])))

(defn customize-report-ui [edit-mode]
  (let [rd    (re-frame/subscribe [:reports/current-rd])
        state (reagent/atom
               {:header-color          (or (get-in @rd [:colors :header-color])
                                           "#68ccca")
                :alternating-rows-odd  (or (get-in @rd [:colors :alternating-rows-odd])
                                           "#FFFFFF")
                :alternating-rows-even (or (get-in @rd [:colors :alternating-rows-even])
                                           "#FFFFFF")})]
    (fn [_]
      [:<>
       [:div.row
        [:div.col-4
         {:style {:padding-right "5px"
                  :padding-left  "0px"}}
         [:div.form-group.border-gray.col-12.p-1
          [:label.report-input-label.col-12.pl-0.pr-0 (i18n/t :header_color)]
          [:div.col-12.inner-colors-container-90
           [color-pickers/popup-picker
            (:header-color @state)
            #(swap! state assoc :header-color %)
            ""
            "xs-l-m20"
            (fn [_]
              (log/info :customize-report-ui :save @state)
              (re-frame/dispatch [:reports/update-current-rd :colors @state])
              (reset! edit-mode :create-screen))]]]]
        [:div.form-group.border-gray.col-8.p-1.colors-container
         [:label.report-input-label.col-12.pl-0.pr-0 (i18n/t :alternating_rows)]
         [:div.col-6.inner-colors-container-45
          [color-pickers/popup-picker
           (:alternating-rows-odd @state)
           #(swap! state assoc :alternating-rows-odd %)
           "0px 5px 0px 0px"
           "xs-l-m50"
           (fn [_]
             (log/info :customize-report-ui :save @state)
             (re-frame/dispatch [:reports/update-current-rd :colors @state])
             (reset! edit-mode :create-screen))]]
         [:div.col-6.inner-colors-container-45
          [color-pickers/popup-picker
           (:alternating-rows-even @state)
           #(swap! state assoc :alternating-rows-even %)
           ""
           "xs-l-m100"
           (fn [_]
             (log/info :customize-report-ui :save @state)
             (re-frame/dispatch [:reports/update-current-rd :colors @state])
             (reset! edit-mode :create-screen))]]]]])))

(defn customize-charts-ui [edit-mode]
  (let [all-charts      (re-frame/subscribe [:reports/current-all-charts])
        entity          (re-frame/subscribe [:reports/selected-entity])
        selected-charts (re-frame/subscribe [:reports/current-selected-charts])]
    (fn [edit-mode]
      (let [fields-map    (->> @all-charts
                               (map
                                (fn [field]
                                  [(:field field) field]))
                               (into {}))
            displayed     (->> @selected-charts
                               (map
                                (fn [field]
                                  (when-let [fd (get-in fields-map [field :name])]
                                    [field fd])))
                               (remove nil?))
            displayed-set (set @selected-charts)
            available     (->> @all-charts
                               (remove #(contains? displayed-set (:field %)))
                               (map
                                (fn [field]
                                  [(:field field) (:name field)])))]
        [report-definition-items-selector
         {:header (i18n/t :available)
          :items  available}
         {:header (i18n/t :displayed)
          :items  displayed}
         (fn [left right]
           (re-frame/dispatch
            [:reports/update-current-rd :charts (map first right)])
           (reset! edit-mode :create-screen))
         (fn []
           (reset! edit-mode :create-screen))]))))

(defn customize-notify-ui [edit-mode]
  (let [all-users (re-frame/subscribe [:reports/users])
        rd        (re-frame/subscribe [:reports/current-rd])]
    (fn [edit-mode]
      (let [users-map     (->> @all-users
                               (map
                                (fn [user]
                                  [(:id user) user]))
                               (into {}))
            displayed     (map
                           (fn [user]
                             [user (get-in users-map [user :name])])
                           (:notify @rd))
            displayed-set (set (:notify @rd))
            available     (->> @all-users
                               (remove #(contains? displayed-set (:id %)))
                               (map
                                (fn [user]
                                  [(:id user) (:name user)])))]
        [report-definition-items-selector
         {:header (i18n/t :available)
          :items  available}
         {:header (i18n/t :notifying)
          :items  displayed}
         (fn [left right]
           (re-frame/dispatch
            [:reports/update-current-rd :notify (map first right)])
           (reset! edit-mode :create-screen))
         (fn []
           (reset! edit-mode :create-screen))]))))

(defn modal-report-definition-header-ui [title]
  (let [data (re-frame/subscribe [:reports/modal-data])]
    (fn []
      [:div.modal-header.card-heading.text-center
       [:button.btn.btn-secondary.close.report-close-modal
        {:type     :button
         :title    (i18n/t :cancel)
         :on-click (fn [e]
                     (when
                       (or (not (:dirty? @data))
                           (js/window.confirm (i18n/t :changes_will_be_lost)))
                       (re-frame/dispatch [:reports/close-modal])))}
        [:i.fa.fa-close]]
       [:h5.modal-title.text-center title]])))

(defn new-modal-report-definition-header-ui [title]
  (let [data (re-frame/subscribe [:reports/modal-data])]
    (fn []
      [:div.modal-heading-padding.modal-color.text-center.flex-container
       {:style {:text-align "center"}}
       [:legend.c-modal-title.text-start.title
         [:button.btn.btn-secondary.close.report-close-modal
          {:type     :button
           :title    (i18n/t :cancel)
           :on-click (fn [e]
                       (re-frame/dispatch [:reports/error-msg-clean])
                       (when
                         (or (not (:dirty? @data))
                             (js/window.confirm (i18n/t :changes_will_be_lost)))
                         (re-frame/dispatch [:reports/close-modal])))}
          [:i.fa.fa-close]]
        title]])))

(defn modal-report-definition-footer-ui [edit-mode updating? dirty? new? rd re-run?]
  [:div.report-modal-footer.text-center
   [:div
    (when new?
      [:button.btn.btn-link.modal-color.float-left.pl-20.pr-0
       {:type     :button
        :on-click (fn [e]
                    (.preventDefault e)
                    (reset! edit-mode :choice-screen)
                    (re-frame/dispatch [:reports/error-msg-clean])
                    (re-frame/dispatch [:reports/modal-data-reset])
                    (re-frame/dispatch
                     [:reports/update-current-rd
                      :run-filter-by          ()
                      :run-filter-by-criteria ()
                      :name                   ""]))}
       (str "<< " (i18n/t :choose_a_different_report))])
    [:button.btn.btn-primary.float-right.btn-modal-color
     {:type     :button
      :disabled (or (not= :create-screen @edit-mode)
                    @updating?
                    (not @dirty?))
      :title    (if new? (i18n/t :create) (i18n/t :update))
      :on-click (fn [_]
                  (let [{:keys [entity type filter-by run-filter-by uri schedule notify]} @rd
                          schedule-type (:type schedule)]
                    (mixpanel/track "Create New Report - Save" {"Entity name" entity
                                                                "Report type" type
                                                                "Filters"     (if (and (nil? filter-by)
                                                                                       (nil? run-filter-by)) "No" "Yes")
                                                                "Scheduled"   (if (= "manual" schedule-type) "No" "Yes")
                                                                "Notify emails" (if (seq notify) "Yes" "No")})
                  (if new?
                    (re-frame/dispatch [:reports/create-report-definition])
                    (re-frame/dispatch [:reports/update-report-definition uri]))))}
     [:i.fa.fa-save.fa-fw]
     (if new?
       (i18n/t :create)
       (if (and (= "manual" (get-in @rd [:schedule :type])) @re-run?)
         (i18n/t :update_and_re_run)
         (i18n/t :update)))
     (when @updating?
       [:span.ms-1
        [spinners/mux-spinner {:size  :text
                               :color :inverted}]])]]])

(defn modal-reports-definition-footer-customize-ui [edit-mode]
  [:div.modal-footer
   [:div.btn-group
     [:button.btn.btn-primary.btn-modal-color
      {:type     :button
       :on-click #(reset! edit-mode :create-screen)}
      "Back"]]])

(defn modal-report-definition-advanced-ui [edit-mode]
  [:div.row.pt-4
   [:label.col-12.report-input-label (i18n/t :color_customization)]
   [:div.col-12.pt-2.color-costimize-div
    [:div.col-12.modal-body-height
     [customize-report-ui edit-mode]]]])

(defn modal-confirmation-dialog []
  (let [data (re-frame/subscribe [:reports/confirmation-dialog])]
    (fn []
      (let [has-instances? (boolean (get-in @data [:payload :instance :key]))]
        [:div.modal-content.modal-color-width
         (dom/add-test-id
           {:class (if has-instances?
                     "border-danger"
                     "border-secondary")}
           "delete-confirm-dialog")
         [:div.modal-header.card-heading.delete-report-panel-danger
          [:button.btn-secondary.close.report-close-modal
           {:type     :button
            :title    (i18n/t :cancel_btn)
            :on-click #(re-frame/dispatch [:reports/close-confirmation-dialog])}
           [:i.fa.fa-close]]
          [:h6.fw-bold.modal-title (i18n/t :confirmation_header)]]
         [:div.modal-body
          [:p.lh-normal (i18n/t :delete_confirmation_body)]]
         [:div.modal-footer
          [:div.btn-group
           (when has-instances?
             [:button.btn.btn-danger.delete-report-btns
              (dom/add-test-id
                {:type     :button
                 :on-click #(re-frame/dispatch
                             [:reports/delete-report-instance
                              (get-in @data [:payload :rd])
                              (get-in @data [:payload :instance :delete-uri])])}
                "delete-confirm-btn-instance")
              (i18n/t :delete_instance_btn)])
           [:button.btn.btn-danger.delete-report-btns
            (dom/add-test-id
              {:type     :button
               :on-click #(re-frame/dispatch
                           [:reports/delete-report-definition (get-in @data [:payload :rd])])}
              "delete-confirm-btn-all")
            (if has-instances?
              (i18n/t :delete_all_instances_btn)
              (i18n/t :delete_report_definition_btn))]
            [:button.btn.delete-report-cancel
             {:type     :button
              :on-click #(re-frame/dispatch [:reports/close-confirmation-dialog])}
             (i18n/t :cancel_btn)]
           ]]]))))

(defn instances-choices []
  (let [choices @(re-frame/subscribe [:reports/get-choices])]
    [:div.col-6
     [:h4
      "Requirements"]
     [:div.row
      (for [choice (:requirement choices)]
        [:button.col-3
         [:h5
          (:header choice)]
         [:p
          (:short-desc choice)]])]
     [:hr.style1]]))

;; Small helper to keep click handlers concise and consistent
(defn choose-report!
  [{:keys [entity type choice first-field edit-mode]}]
  (when (#{"Instance" "Run"} entity)
    (re-frame/dispatch [:reports/update-current-rd :aggregation-x-field first-field]))
  (re-frame/dispatch [:reports/update-entity entity])
  (re-frame/dispatch [:reports/update-type type])
  (re-frame/dispatch [:reports/update-fields entity])
  (re-frame/dispatch [:reports/update-type-name (:type choice)])
  (re-frame/dispatch [:reports/set-selected-choice choice])
  (re-frame/dispatch [:reports/move-details-screen edit-mode]))

(defn choices-modal [entity-key grid-size choice-size edit-mode display-underline]
  (let [choices     (re-frame/subscribe [:reports/get-choices])
        curr-object (entity-key @choices)
        entity      (:object-name curr-object)
        star-image  (re-frame/subscribe [:reports/recomended-image-url])
        fields      (re-frame/subscribe [:reports/aggregation-fields entity])
        first-field (ffirst @fields)]
    [:div.position-relative
     {:class grid-size}
     [:h5.modal-color
      (:header curr-object)]
     [:div.row
      {:style {:margin-left "0px"
               :margin-bottom "20px"}}
      (doall
        (for [[header choice] (:types (entity-key @choices))]
          (let [image (re-frame/subscribe (:image choice))]
            ^{:key (str header "-" (:type choice))}
            [:div
             {:class (str choice-size " choice-box position-relative")}
             [:button
              {:class    "col-12 text-start"
               :id       (:dom-id choice)
               :on-click (fn [e]
                           (.preventDefault e)
                           (choose-report! {:entity      entity
                                            :type        header
                                            :choice      choice
                                            :first-field first-field
                                            :edit-mode   edit-mode})
                           (.track js/mixpanel "Create New Report - Create" #js {:Entity entity :Type (:type choice)}))}
              [:div.absolute-top.pr-10
               [:h5.choice-report-name
                (:type choice)]
               [:div.x-small-font
                (:short-desc choice)]]
              [:div.absolute-bottom-right
               [:img.rounded.img-fluid.choice-box-image
                {:src @image}]]]
             (when (:star choice)
               [:img.recomended-image.recomended-image-position
                {:src @star-image}])])))]
     (when display-underline
       [:hr.underline.col-11])]))

(defn details [edit-mode]
  (let [typeName       (re-frame/subscribe [:reports/selected-type-name])
        type           (re-frame/subscribe [:reports/selected-type])
        entity         (re-frame/subscribe [:reports/selected-entity])
        choice         (re-frame/subscribe [:reports/selected-choice])
        image          (re-frame/subscribe (:image @choice))
        example-image  (re-frame/subscribe (:image-example @choice))]
    [:div.row.pr-20
     [:div.col-12.flex-container
      [:div.right.col-4.col-sm-2.pb-20
       [:div.border-gray.flow-root.rounded.pt-20.pb-20.m-10
        [:h6.text-center.col-12 @typeName]
        [:img.rounded.img-fluid.center-block.details-box-image {:src @image}]]]
      [:div.col-12.col-sm-10.border-gray.rounded.p-20.m-10.details.flex
       [:div.col-12.col-sm-6.r-border.long-text-area.pb-35.mt-10
        [:h5.modal-color
         (i18n/t (keyword (string/replace (str @entity "_" @type "_Report") #" " "_")))]
        [:p.lh-24.pb-50.pr-10
         (str (:long-text @choice))]
        [:div.absolute-bottom.long-text-seperator.pl-15.pr-15.pb-5.row.col-5
         [:div.row.flex-container
          [:button.btn.btn-link.col-7.pl-0.text-align-left
           {:type     "button"
            :style    {:font-size   "14px"}
            :on-click (fn [e]
                        (.preventDefault e)
                        (reset! edit-mode :choice-screen))}
           (str "< " (i18n/t :choose_a_different_report))]
          [:button.btn.btn-primary.btn-modal-color.col-5
           {:style    {:width        "145px"
                       :white-space  "nowrap"
                       :overflow     "hidden"
                       :text-overflow "ellipsis"
                       :font-size    "14px"}
            :type     "button"
            :title    (str (i18n/t :i_want_this_report) " >")
            :on-click (fn [e]
                        (.preventDefault e)
                        (reset! edit-mode :create-screen))}
           (str (i18n/t :i_want_this_report) " >")]]]]
       [:div.col-12.col-sm-6.mt-10.m-10.pr-10
        [:a
         {:href   @example-image
          :target "_blank"}
         [:img.rounded.img-fluid
          {:src @example-image}]]]]]]))

(defn display-star []
  (let [star-image @(re-frame/subscribe [:reports/recomended-image-url])]
    [:div
     {:class "col-12"}
     [:div
      {:style {:height "30px"}}
      [:div.row
       [:div.recomended-position
        [:img.recomended-image
         {:src star-image}]
        (i18n/t :most_recommended)]]]]))

(defn choice-row [left-col right-col edit-mode display-underline?]
  [:div.row.flex-row
   (if (not (nil? left-col))
     [choices-modal
      left-col
      (str "col-12 col-sm-6 col-lg-5 mb-3")
      (str "col-5 col-sm-6 col-lg-4 col-sm-4 mb-3")
      edit-mode
      display-underline?])
   (if (not (nil? right-col))
     [choices-modal
      right-col
      "col-12 col-sm-6 col-lg-7 pl-3 mb-3"
      "col-5 col-sm-6 col-lg-3 mb-3"
      edit-mode
      display-underline?]
     [display-star])])

(defn modal-report-definition-ui []
  (let [rd        (re-frame/subscribe [:reports/current-rd])
        updating? (re-frame/subscribe [:reports/report-definition-updating?])
        dirty?    (re-frame/subscribe [:reports/modal-dirty?])
        re-run?   (re-frame/subscribe [:reports/modal-re-run?])
        error     (re-frame/subscribe [:reports/error])
        typeName  (re-frame/subscribe [:reports/selected-type-name])
        type      (re-frame/subscribe [:reports/selected-type])
        entity    (re-frame/subscribe [:reports/selected-entity])
        screen    (re-frame/subscribe [:reports/screen])
        edit-mode (if (or (= @screen :create-screen) (not (nil? (:id @rd))) (string/includes? (:name @rd) "Clone of"))
                    (reagent/atom :create-screen)
                    (reagent/atom :choice-screen))]
    (fn []
      (let [new? (nil? (:id @rd))]
        (case @edit-mode
          :choice-screen    [:div.modal-content.modal-color-width
                             {:class (if @error "border-danger" "border-secondary")}
                             [new-modal-report-definition-header-ui
                              (if new?
                                (i18n/t :create_a_new_report)
                                (i18n/t :edit_report_definition))]
                             [:div.modal-body.modal-auto-scroll
                              {:style {:padding-top "0px"}}
                              [choice-row nil nil false]
                              [:div.row {:style {:height "15px"}}]
                              [errors-ui]
                              [choice-row :requirement :instances edit-mode true]
                              [choice-row :tests :issues edit-mode true]
                              [choice-row :testsets :runs edit-mode false]]]
          :details-screen   [:div.modal-content.rounded-0.modal-color-width
                             {:class (if @error "border-danger" "border-secondary")}
                             [new-modal-report-definition-header-ui
                              (if new?
                                (i18n/t :create_a_new_report)
                                (i18n/t :edit_report_definition))]
                             [:div.modal-body.modal-auto-scroll
                              [errors-ui]
                              [details edit-mode]]]
          :create-screen    [:div.modal-content.modal-color-width.modal-auto-scroll
                             {:class (if @error "border-danger" "border-secondary")}
                             [new-modal-report-definition-header-ui
                              (if new?
                                (i18n/t :create_a_new_report)
                                (i18n/t :edit_report_definition))]
                             [:div.modal-body
                              [errors-ui]
                              [:form.form-inline.row
                               [:div.col-12
                                [:div.col-12
                                 [:h5.modal-color.mb-15.ml-14
                                  (i18n/t (keyword (string/replace (str @entity "_" @type "_Report") #" " "_")))]]
                                [:div.flex-row
                                 [:div.col-12.col-sm-6.last-screen-fields.pr-15.pl-15
                                 [modal-report-definition-name-ui]
                                 (if (and (= @entity "Instance") 
                                          (or (= @type "tabular") (= @type "tabular-with-steps") (= @type "detailed-with-attachments")))
                                   [modal-report-definition-instance-tabular-summary-filter-ui]
                                   [modal-report-definition-filter-ui])

                                  (case (:type @rd)
                                   "tabular"
                                   [:<>
                                    [modal-report-definition-fields-ui edit-mode]
                                    [modal-report-definition-charts-ui edit-mode]]

                                   "tabular-with-steps"
                                   [:<>
                                    [modal-report-definition-fields-ui edit-mode]
                                    [modal-report-definition-charts-ui edit-mode]
                                    [modal-report-definition-advanced-ui edit-mode]]

                                   "tabular-traceability"
                                   [modal-report-definition-fields-ui edit-mode]

                                   "tabular-aggregated"
                                   [modal-report-definition-aggregation-ui edit-mode entity]

                                   ("detailed" "detailed-with-attachments")
                                   [modal-report-definition-type-ui]

                                   nil)]
                                [:div.col-12.col-sm-6.pr-15.pl-15
                                 [:div.col-12.bg-white.pr-15.pl-15
                                  [:div.col-12
                                   [:h6 [:u (i18n/t :reports_settings)]]]
                                  [modal-report-definition-schedule-ui]
                                  [:div.col-12
                                   [modal-report-definition-users-ui edit-mode]]]]]]]]
                             [modal-report-definition-footer-ui edit-mode updating? dirty? new? rd re-run?]]
          :customize-fields [:div.modal-content.border-secondary.modal-color-width
                             [modal-report-definition-header-ui
                              (i18n/t :select_fields)]
                             [:div.modal-body.modal-auto-scroll
                              [customize-fields-ui edit-mode]]]
          :customize-charts [:div.modal-content.border-secondary.modal-color-width
                             [modal-report-definition-header-ui
                              (i18n/t :select_charts)]
                             [:div.modal-body.modal-auto-scroll
                              [customize-charts-ui edit-mode]]]
          :customize-notify [:div.modal-content.border-secondary.modal-color-width
                             [modal-report-definition-header-ui
                              (i18n/t :select_users_to_notify)]
                             [:div.modal-body.modal-auto-scroll
                              [customize-notify-ui edit-mode]]])))))
(defn help-panel []
  (let [show?          (reagent/atom false)
        help-image-url (re-frame/subscribe [:reports/help-image-url])]
    (fn []
      [:div.p-3.bg-light.border
       [:span
        {:aria-hidden             true
         :dangerouslySetInnerHTML {:__html (i18n/t :report_engine_well_html)}}]
       (if @show?
         [:div.d-grid
          [:a
           {:href     "#"
            :on-click (fn [e]
                        (.preventDefault e)
                        (reset! show? false))}
           (i18n/t :hide_details)]
          [:img.rounded.img-fluid {:src @help-image-url}]
          [:a
           {:href     "#"
            :on-click (fn [e]
                        (.preventDefault e)
                        (reset! show? false))}
           (i18n/t :hide_details)]]
         [:div
          [:a
           {:href     "#"
            :on-click (fn [e]
                        (.preventDefault e)
                        (reset! show? true))}
           (i18n/t :see_details)]])])))

(defn main-panel []
  (reagent/create-class
   {:component-did-mount
    (fn [_]
      (let [export-params @(re-frame/subscribe [:reports/export])
            ;; Additionally support SPA redirects with query params from Filters context menu
            qp            (router/get-current-query-params)
            qp-entity     (get qp :export_entity)
            qp-cv         (get qp :export_cv)
            qp-cv-name    (get qp :export_cv_name)
            qp-fields     (get qp :export_fields)]
        (cond
          ;; Legacy path: backend provided :export in reports init options
          export-params
          (re-frame/dispatch [:reports/new-export export-params])

          ;; SPA path: parse query params and dispatch directly
          (and qp-entity qp-cv qp-cv-name)
          (re-frame/dispatch [:reports/new-export {:entity  qp-entity
                                                   :cv      qp-cv
                                                   :cv-name qp-cv-name
                                                   :fields  qp-fields}]))))

    :reagent-render (let [loading? (re-frame/subscribe [:reports/loading?])]
                      (fn []
                        (let [suite-id @(re-frame/subscribe [:reports/testset-id-for-instances-filter])]
                          [:div.grid-page
                           [:div.container-fluid.old-frontend-inner-container
                            [m1/window
                             {:data-subscription    [:reports/modal-data]
                              :backdrop-click-event [:reports/close-modal]
                              :escape-key-event     [:reports/close-modal]
                              :body                 [modal-report-definition-ui]}]
                            [m1/window
                             {:data-subscription    [:reports/confirmation-dialog]
                              :backdrop-click-event [:reports/close-confirmation-dialog]
                              :escape-key-event     [:reports/close-confirmation-dialog]
                              :body                 [modal-confirmation-dialog]}]
                            [:div.row
                             [:div.col-md-12
                              [:legend (i18n/t :report_center)]
                              [help-panel]]]
                            [:div.row
                             (if @loading?
                               [:div.col-md-12.text-center
                                [spinners/mux-spinner {:size :modal}]]
                               [reports-ui])
                             (when (and (not (nil? suite-id))
                                        (not (empty? (str suite-id))))
                               (re-frame/dispatch [:reports/testset-instances-report]))]]])))}))
